// extracted by mini-css-extract-plugin
export default {"iconMore":"styles_iconMore__J2+vr"};